import { render, staticRenderFns } from "./videoAlertView.vue?vue&type=template&id=263f2523"
import script from "./videoAlertView.vue?vue&type=script&lang=js"
export * from "./videoAlertView.vue?vue&type=script&lang=js"
import style0 from "./videoAlertView.vue?vue&type=style&index=0&id=263f2523&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports